import React, { useState } from "react";
import SearchDetails from "./searchDetails";

const SearchEmployeeData = () => {

  const [apiData, setApiData] = useState(null);
  console.log(apiData , "ApiData")

  return (
    <div>
      <SearchDetails apiData={apiData} setApiData={setApiData} />
    </div>
  );
};

export default SearchEmployeeData;